import _ from 'underscore';
import angular from 'angular';
import moment from 'moment';

function AdmissionGroupCommissionsCtrl($scope, admissionGroupService, sdkUtils, alertService) {
  if (!$scope.admissionGroups) throw new Error('admission-group-commissions directive - admissionGroups is required on scope');

  $scope.admissionGroups = angular.copy($scope.admissionGroups).map(admissionGroup => {
    admissionGroup.date = moment.utc(admissionGroup.date.toISOString());
    return admissionGroup;
  });

  $scope.updateAdmissionGroupCommission = _.throttle(_updateAdmissionGroupCommission, 200, {
    leading: false
  });

  function _updateAdmissionGroupCommission(admissionGroup, $event) {
    if (!admissionGroup) return null;
    if ($event) $event.preventDefault();

    const newPercent = admissionGroup.addedByCommission ? parseFloat(admissionGroup.addedByCommission.amount) : 0;

    if (isNaN(newPercent)) {
      return false;
    }

    const payment = (newPercent / 100) * admissionGroup.spent;

    const commission = {
      type: 'PERCENT',
      value: payment,
      amount: newPercent
    };

    admissionGroup.addedByCommission = commission;

    return admissionGroupService.updateById(admissionGroup.id, {
        addedByCommission: commission
      })
      .then(function (updatedAdmissionGroup) {
        _.extend(admissionGroup, updatedAdmissionGroup);

        alertService.success('Commission Updated');
      })
      .catch(function (error) {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }
}

AdmissionGroupCommissionsCtrl.$inject = [
  '$scope',
  'jsSdk.admissionGroup',
  'jsSdk.utils',
  'alertService'
];

export default AdmissionGroupCommissionsCtrl;



// WEBPACK FOOTER //
// ./src/directives/admissionGroupCommissions/controller.js